import React from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { STRINGS } from '@/app/constants/componentStrings';
import { Button } from 'primereact/button';
import DocumentImageService from '@/app/api/service/DocumentImageService';
import Formatacao from '@/app/util/formatacao';
import {Dialog} from 'primereact/dialog';

function Aditivos ({ aditivos }){

    const [state, setState] = React.useState({
        expandedRows: [],
        showDialog: false,
        aditivoSelecionado: {documentos:[]}
    })

    const showDocuments = (aditivo) => {
        setState({
            aditivoSelecionado: aditivo,
            showDialog: true
        })
    }

    const dataAssinaturaAditivoTemplate = (rowData) => {
        return <span >{Formatacao.localDate(rowData.assinatura)}</span>
    }

    const dataPublicacaoAditivoTemplate = (rowData) => {
        return <span className="center">{Formatacao.localDate(rowData.publicacao)}</span>
    }

    const documentacaoColumnTemplate = (rowData, column) => {
        return <Button onClick={e => showDocuments(rowData)} label="Documentação" type="button" icon="pi pi-folder-open" className="p-button-success"></Button>
    }

    return(
        <React.Fragment>
            <DataTable value={aditivos} emptyMessage={STRINGS.emptyMessage} >
                <Column field="numero" header="Número" />
                <Column field="viproc" header="Viproc" />
                <Column field="descricaoTipo" header="Tipo" />
                <Column header="Assinatura" body={dataAssinaturaAditivoTemplate} className="t-center"/>
                <Column header="Publicação" body={dataPublicacaoAditivoTemplate} className="t-center"/>                
                <Column header="" body={documentacaoColumnTemplate} className="t-center"/>                
            </DataTable>

            <Dialog header="Documentação do Aditivo" 
                    style={{ width: '800px' }}
                    visible={state.showDialog} modal={true} 
                    onHide={(e) => setState({showDialog: false,aditivoSelecionado: {documentos:[]}})}>

                <DataTable value={state.aditivoSelecionado.documentos} emptyMessage={STRINGS.emptyMessage} 
                           rows={10} alwaysShowPaginator={false}
                           paginator={true} paginatorPosition="bottom" >
                    <Column field="descricaoTipoDocumento" header="Documento" />
                    <Column field="nomeArquivo" header="Arquivo" />
                    <Column className="coluna-acao" body={
                        (data) => (
                            <Button type="button"
                                onClick={ e => { e.preventDefault(); DocumentImageService.visualizarDocumento('aditivo', data.id)} }
                                icon="pi pi-download" 
                                className="p-button-primary"
                                style={{marginRight: '.5em'}}>
                            </Button>
                        )
                    } />
                 
                </DataTable>
            </Dialog>
        </React.Fragment>
    )
}

export default Aditivos
